export default "__VITE_ASSET__D4uTsgYH__"